import { useCallback, useState } from 'react'
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom'

import PrivateRoute from './auth/privateroute'
import { BASE_URL } from './constants'
import DetailsPage from './pages/DetailsPage'
import HazardsPage from './pages/HazardsPage'
import MainPage from './pages/MainPage'

import LoginPage from './pages/LoginPage'
import { ScrollToTop } from './pages/util'

function App() {
  const [acceptedDisclaimer, setAcceptedDisclaimer] = useState(false)

  const acceptDisclaimer = useCallback(() => setAcceptedDisclaimer(true), [])
  const declineDisclaimer = useCallback(() => { window.location = 'https://www.horrycountysc.gov'; }, [])

  return (
    <Router basename={BASE_URL}>
      <Switch>
        <Route path="/login">
          <LoginPage/>
        </Route>
        <Route path="/flood-info">
          <HazardsPage acceptDisclaimer={acceptDisclaimer} acceptedDisclaimer={acceptedDisclaimer} declineDisclaimer={declineDisclaimer} />
        </Route>
        <PrivateRoute path="/details/:pin">
          <DetailsPage acceptDisclaimer={acceptDisclaimer} acceptedDisclaimer={acceptedDisclaimer} declineDisclaimer={declineDisclaimer} />
        </PrivateRoute>
        <PrivateRoute exact path="/" >
          <MainPage acceptDisclaimer={acceptDisclaimer} acceptedDisclaimer={acceptedDisclaimer} declineDisclaimer={declineDisclaimer} />
        </PrivateRoute>
      </Switch>
      <ScrollToTop />
    </Router>
  );
}

export default App;
